var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.864,
    height: 32.12,
    viewBox: "0 0 31.864 32.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M17.931,2A15.931,15.931,0,0,1,33.862,17.931a15.93,15.93,0,1,1-31.856.516L2,17.931l.006-.446A15.93,15.93,0,0,1,17.931,2Zm0,14.338H16.338l-.186.011a1.593,1.593,0,0,0,0,3.164l.186.011V24.3l.011.186a1.593,1.593,0,0,0,1.4,1.4l.186.011h1.593l.186-.011a1.593,1.593,0,0,0,1.4-1.4l.011-.186-.011-.186a1.593,1.593,0,0,0-1.217-1.365l-.178-.032-.186-.01V17.931l-.011-.186a1.593,1.593,0,0,0-1.4-1.4Zm.016-4.779-.2.011a1.593,1.593,0,0,0,0,3.164l.186.011.2-.011a1.593,1.593,0,0,0,0-3.164Z",
    transform: "translate(-2 -2)",
    fill: "#807ce0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleLg);
export default __webpack_public_path__ + "static/media/info-circle-lg.eb5b04529a163924fa3c63d3658fbf96.svg";
export { ForwardRef as ReactComponent };